import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    // Paper itself does not scroll (overflow hidden keeps the rounded corners
    // clean); the inner `body` scrolls, and only shows a scrollbar once its
    // content actually overflows the available height.
    paper: {
        borderRadius: 4,
        overflowY: 'hidden',
        padding: '24px 32px 32px',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexShrink: 0,
        marginBottom: 24,
    },
    title: {
        fontSize: 22,
        fontWeight: 700,
        lineHeight: 1.2,
    },
    subtitle: {
        marginTop: 4,
        color: theme.palette.text.secondary,
    },
    closeButton: {
        marginTop: -8,
        marginRight: -8,
    },
    body: {
        flex: '1 1 auto',
        overflowY: 'auto',
        overflowX: 'hidden',
        // Reserve the vertical scrollbar's gutter unconditionally, so the width
        // available to the cards grid is constant regardless of whether the
        // scrollbar actually renders, or renders as a classic (space-occupying)
        // vs overlay scrollbar — a classic scrollbar appearing (e.g. mouse
        // connected on macOS, which switches away from overlay scrollbars) was
        // otherwise enough to tip the 3-card row down to 2. dialogMaxWidth in
        // index.jsx budgets extra width (SCROLLBAR_ALLOWANCE) to compensate.
        scrollbarGutter: 'stable',
    },
}));
